/**
 * 尚未綁定App - 提示控制
 *
 * 顯示時機:
 *   每次登入後顯示一次。登入成功時打上標記 (sessionStorage), 由路由守衛取出並清除,
 *   所以換頁 / 重新整理都不會重複跳出, 但重新登入就會再提示一次。
 *
 * 不再顯示:
 *   對話框勾選「不再顯示此提示」後寫入 cookie (依管理員uuid區分, 保存一年),
 *   之後即使重新登入也不再提示; 綁定入口仍常駐在「個人資料」頁, 隨時可自行前往。
 */

//sessionStorage - 本次登入待提示
const PENDING_KEY = "mappingNoticePending"

//cookie - 不再顯示 (前置, 後面接管理員uuid)
const DISABLED_KEY = "mappingNoticeOff"

//cookie - 保存天數
const DISABLED_DAYS = 365

export const useMappingNotice = () => {

    /**
     * 讀取 - cookie
     */
    const getCookie = (key) => {

        const row = document.cookie
            .split("; ")
            .find((i) => i.startsWith(`${key}=`))

        if (row === undefined) return null

        return decodeURIComponent(row.substring(key.length + 1))

    }

    /**
     * 寫入 - cookie
     */
    const setCookie = (key, value, days) => {

        const expire = new Date()

        expire.setTime(expire.getTime() + days * 24 * 60 * 60 * 1000)

        //https才帶Secure (本機開發為http)
        const secure = location.protocol === "https:" ? "; Secure" : ""

        document.cookie = `${key}=${encodeURIComponent(value)}; expires=${expire.toUTCString()}; path=/; SameSite=Lax${secure}`

    }

    /**
     * 標記 - 本次登入要提示 (登入成功後呼叫)
     */
    const markMappingNotice = () => sessionStorage.setItem(PENDING_KEY, "1")

    /**
     * 取出 - 本次登入是否要提示 (取出後即清除, 每次登入只會提示一次)
     */
    const takeMappingNotice = () => {

        if (!sessionStorage.getItem(PENDING_KEY)) return false

        sessionStorage.removeItem(PENDING_KEY)

        return true

    }

    /**
     * 是否 - 使用者已勾選不再顯示
     * @param uuid 管理員uuid
     */
    const isMappingNoticeDisabled = (uuid) => getCookie(`${DISABLED_KEY}_${uuid}`) === "1"

    /**
     * 關閉 - 不再顯示提示
     * @param uuid 管理員uuid
     */
    const disableMappingNotice = (uuid) => setCookie(`${DISABLED_KEY}_${uuid}`, "1", DISABLED_DAYS)

    return {
        markMappingNotice,
        takeMappingNotice,
        isMappingNoticeDisabled,
        disableMappingNotice,
    }

}
